module.exports = __webpack_public_path__ + "static/media/iconCanvas09.09df34bc.svg";